import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="rental-search"
export default class extends Controller {
  static targets = ["form", "results", "query", "dateStart", "dateEnd", "category", "loadingIndicator"]
  
  connect() {
    console.log("Rental search controller connected")
  }
  
  search(event) {
    if (event) {
      event.preventDefault()
    }
    
    this.showLoadingIndicator()
    
    const url = this.formTarget.action
    const formData = new FormData(this.formTarget)
    
    fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      }
    })
      .then(response => response.text())
      .then(html => {
        this.hideLoadingIndicator()
        Turbo.renderStreamMessage(html)
      })
      .catch(error => {
        this.hideLoadingIndicator()
        console.error("Error in rental search:", error)
      })
  }
  
  showLoadingIndicator() {
    if (this.hasLoadingIndicatorTarget) {
      this.loadingIndicatorTarget.classList.remove("hidden")
    }
  }
  
  hideLoadingIndicator() {
    if (this.hasLoadingIndicatorTarget) {
      this.loadingIndicatorTarget.classList.add("hidden")
    }
  }
  
  reset() {
    this.formTarget.reset()
    this.search()
  }
}
